/**
 * @description 上传文件APi
 */

import request from '@/utils/request'

/**
 * 获取上传Oss参数
 * @param {Object} data { type: String } type=上传的目录
 * @returns {Object} 返回上传参数
 */
export const getUploadOssParams = data => (request({
    params: data,
    url: 'upload/getSignedUrl'
}))


/**
 * 上传到服务器本地(导入模板)
 * @param {Object} data FileData
 * @returns {response} 返回上传文件路径
 */
export const uploadFile = data => (request({
    data,
    method: "POST",
    url: 'upload/upload'
}))